import React, { useState, useEffect } from "react";
import { Text, StyleSheet, View, Platform } from "react-native";

import cardStyles from "./cardStyles";

import { pluralize } from "../../../../helpers/utils";
import CloseIcon from "../../common/dialog/CloseIcon";
import CardUtils from "./CardUtils";
import ManaButton from "../../common/ManaButton";
import AppTheme from "../../AppTheme";
import appPages from "../../../../appPages";
import CommentUnreadIcon from "../../common/icons/reports/CommentUnreadIcon";

export default function NewReportsCommentsCard({
  controller,
  data = {},
  isSnoozed = false,
  onSnooze = null,
}) {
  const [showCard, setShowCard] = useState(true);
  const cardUtils = new CardUtils(controller, data, setShowCard);
  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  const dataModel = data;
  const title = `${pluralize("New Comment", dataModel.count || 1)}`;

  // ------------------------------------- METHODS -------------------------------------
  const viewComments = () => {
    controller.navigation?.jumpTo(appPages.receivedReports, {
      type: data.report_type,
    });
  };

  return !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 80, height: "auto" }]}>
        <CloseIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          style={cardStyles.closeButton}
        />
        <View style={[cardStyles.header, { paddingHorizontal: 0, height: 24 }]}>
          <CommentUnreadIcon width={20} height={20} />

          <View style={[cardStyles.headerInfo, { marginLeft: 6 }]}>
            <Text style={cardStyles.title}>{title}</Text>
          </View>
        </View>

        <View style={styles.content}>
          <Text style={styles.textArea}>
            You have {pluralize("new comment", dataModel.count || 1)} to review
            in your team reports discussions.
          </Text>

          <ManaButton
            onPress={viewComments}
            style={[cardStyles.buttonSmall, { minWidth: 60, height: 30 }]}
            styleText={cardStyles.buttonSmallText}
            text="View"
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textArea: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
});
